// External Libraries and Packages
import React, { useEffect, useRef, useState } from "react";
import { ToastContainer } from 'react-toastify';
import { connect, useDispatch } from "react-redux";
import { GlobalStyles } from "./GlobalStyles";
import { ThemeProvider } from "styled-components";
import { useLocation, useNavigate } from 'react-router-dom';
import SkeletonLoader from "./components/Loader/SkeletonLoader";
// Internal Styles
import "./App.css";
import "./Styles/root.css"
import "./Styles/rtl-support.css";
import "./Styles/Swiper.css";
import "./Styles/response.css";
import "./Styles/BoostrapTable.css";
import "./Styles/AuthStyle.css";
// Internal Components
import { allThumbnailAction, getUserTranslateLanguageAction, headerIndexAction, settingAction, getFieldEnable, siteThemeAction, displayTranslateLanguageAction, footerAction, labelAction, allHomePageAction } from "./Redux/Actions/apiActions";
import HelmetDetails from "./components/HelmetDetails";
import { useMyContext } from "./components/Layout/CommonProvider.js";
import AllRoutes from "./Routes/AllRoutes.jsx";
import { HomePageProvider } from "./context/HomePageContext";
import LivestreamPopup from "./components/Common/LivestreamPopup";
import RadioPlayerBar from "./Pages/Music/RadioStation/Components/RadioPlayerBar";
import axios from "axios";
import useFCMToken from "./hooks/useFCMToken";
import useBandwidthRestriction from "./hooks/useBandwidthRestriction";
import BandwidthRestrictedModal from "./components/Common/BandwidthRestrictedModal";
// import { setupGlobalVideoJsErrorHandler } from "./Utils/videoJsErrorHandler";
import ChunkErrorBoundary from "./components/ErrorBoundary/ChunkErrorBoundary";
import { jwtDecode } from "jwt-decode";

function App({ languageDetailsData, siteTheme, settings, themeMode, headerSetting, currentTheme, homepage, isLoading, flimStripe, planContent, headerindexall }) {
  const baseURL = process.env.REACT_APP_Baseurl;
  const [pageData, setPageData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const userData = localStorage.getItem("access_token")
  const user_role = localStorage.getItem("role");
  const user_id = localStorage.getItem("user_id");

  const { navigateTranslateChecker } = useMyContext()

  const headers = React.useMemo(() => ({
    "Content-Type": "application/json", headers: { "Access-Control-Allow-Origin": "*" },
    Authorization: "Bearer " + userData,
  }), [userData]);
  const dispatch = useDispatch()
  const location = useLocation();
  const navigation = useNavigate()

  const [bodyScrollTop, setBodyScrollTop] = useState(0);
  const [isActionDispatched, setIsActionDispatched] = useState(false);
  const sessionExpiredRef = useRef(false);

  const isLaptop = () => {
    const screenWidth = window.innerWidth;
    return screenWidth >= 1024 && screenWidth <= 2000;
  };
  const isMobile = () => {
    const screenWidth = window.innerWidth;
    return screenWidth >= 320 && screenWidth < 1024;
  };
  const { token } = useFCMToken();

  // CDN bandwidth restriction — show blocking modal when limit is reached
  const { restricted: bwRestricted, bandwidthInfo: bwInfo, checking: bwChecking, recheck: bwRecheck } = useBandwidthRestriction();

  const { isOnline } = useMyContext()


  const api = axios.create({
    baseURL: process.env.REACT_APP_Baseurl,
  });

  const [serviceError503, setServiceError503] = useState(false);
  const [serviceError500, setServiceError500] = useState(false);
  const [serviceOfflineModal503, setServiceOfflineModal503] = useState(false);

  const ServiceErrorModal503 = ({ show }) => {
    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable theme-bg-color">
        <div className="modalContentdataserviceunavailable theme-bg-color">
          <h2>Service Unavailable</h2>
          <p>The server is temporarily unavailable. Please contact support or try again later.</p>
        </div>
      </div>
    );
  };

  const fetchLandingPage = async () => {
    try {
      const res = await axios.get(`${baseURL}/Front-end/landing-page`);
      setPageData(res.data.data);
    } catch (err) {
      console.error("Landing page fetch error:", err);
    }
  };

  useEffect(() => {
    if (settings?.enable_landing_page === "1") {
      fetchLandingPage();
    }
  }, [settings?.enable_landing_page]);

  const siteMeta = headerindexall?.site_meta;


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // Deep link token expiration checker
  useEffect(() => {
    const checkDeepLinkExpiry = () => {
      const expiry = localStorage.getItem('access_token_expiry');
      if (expiry && Date.now() > Number(expiry)) {
        console.log("Deep link token expired. Clearing session...");
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_token_expiry');
        localStorage.removeItem('app_return_scheme');
        localStorage.removeItem('user_id');
        localStorage.removeItem('role');
        // Force a redirect to login
        window.location.href = "/login";
      }
    };

    // Check immediately on mount
    checkDeepLinkExpiry();

    // Check periodically (every 30 seconds)
    const interval = setInterval(checkDeepLinkExpiry, 30000);

    return () => clearInterval(interval);
  }, []);

  const getPageMeta = () => {
    if (!siteMeta || siteMeta.length === 0) return null;

    // Handle language prefix and normalize (lowercase, remove trailing slash)
    let normalizedPath = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    normalizedPath = normalizedPath.replace(/^\/[a-z]{3,4}(\/|$)/, '/').replace(/\/$/, '') || '/';

    const PAGE_MAPPING = {
      'categorylist': '/videocategories',
      'audiocategorylist': '/audio-genre',
      'seriescategorylist': '/series-genre',
      'categorylive': '/livecategories',
      'artist-list': '/artists',
      'channel-list': '/channels',
      'content-partners': '/partners',
      'language-list': '/alllanguage',
      'most-watched-videos': '/most-watched-videos',
      'most-watched-videos-country': '/most-watched-videos-country',
      'most-watched-videos-site': '/most-watched-videos-site',
      'continue-watching-list': '/continue-watching',
      'mywishlists': '/mywishlists',
      'watchlater': '/watchlater',
      'myprofile': '/myprofile',
      'transactiondetails': '/subscription-list',
      'upgrade-subscription_plan': '/plan',
      'upgrade-subscription-plan': '/plan',
      'videopage': '/videos',
      'moviepage': '/movies',
      'livepage': '/livestream',
      'seriespage': '/show'
    };

    return siteMeta.find(item => {
      const name = item.page_name?.toLowerCase();
      const slug = item.page_slug?.toLowerCase();

      // 1. Home page special cases
      if (normalizedPath === '/') {
        return name === 'home' || slug === 'home' || slug === '/' || slug === '' || !slug || name === 'latest-videos' || slug === 'latest-videos';
      }

      // 2. Check Mapping
      if (name && PAGE_MAPPING[name] === normalizedPath) return true;
      if (slug && PAGE_MAPPING[slug] === normalizedPath) return true;

      // 3. Exact matches for other pages
      const checkSlug = slug?.startsWith('/') ? slug.toLowerCase().replace(/\/$/, '') : `/${slug?.toLowerCase().replace(/\/$/, '')}`;
      const checkName = name?.startsWith('/') ? name.toLowerCase().replace(/\/$/, '') : `/${name?.toLowerCase().replace(/\/$/, '')}`;

      return checkSlug === normalizedPath || checkName === normalizedPath || name === normalizedPath.substring(1);
    });
  };

  const pageMeta = getPageMeta();

  // Facebook Pixel Injection (Delayed)
  useEffect(() => {
    const fbPixelId = settings?.script_setting?.fb_pixel;

    if (fbPixelId) {
      const timer = setTimeout(() => {
        // 1. Meta Pixel Code initialization
        const fbPixelInit = (f, b, e, v, n, t, s) => {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = "2.0";
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        };

        fbPixelInit(
          window,
          document,
          "script",
          "https://connect.facebook.net/en_US/fbevents.js"
        );

        // 2. Initialize with dynamic ID
        window.fbq("init", fbPixelId);
        window.fbq("track", "PageView");

        // 3. Add noscript fallback
        const noscriptId = "fb-pixel-noscript";
        if (!document.getElementById(noscriptId)) {
          const noscript = document.createElement("noscript");
          noscript.id = noscriptId;
          const img = document.createElement("img");
          img.height = "1";
          img.width = "1";
          img.style.display = "none";
          img.src = `https://www.facebook.com/tr?id=${fbPixelId}&ev=PageView&noscript=1`;
          noscript.appendChild(img);
          document.head.appendChild(noscript);
        }
      }, 3000); // 3-second delay

      return () => clearTimeout(timer);
    }
  }, [settings?.script_setting?.fb_pixel]);


  // Dynamic Google Font Injection
  useEffect(() => {
    const fontUrl = settings?.google_font_url;
    const linkId = 'dynamic-google-font-link';
    const styleId = 'dynamic-google-font-style';

    if (!fontUrl) {
      // Clean up injected elements if the URL is cleared
      document.getElementById(linkId)?.remove();
      document.getElementById(styleId)?.remove();
      return;
    }

    // Use the explicitly set font name, or fall back to parsing the first family from the URL
    let fontFamily = settings?.google_font_name?.trim() || null;
    if (!fontFamily) {
      try {
        fontFamily = new URL(fontUrl).searchParams.get('family')?.split(':')[0]?.replace(/\+/g, ' ') || null;
      } catch (_) { /* invalid URL — skip style override */ }
    }

    // Inject or update the <link> tag
    // Set href BEFORE appending to DOM — prevents empty-href error triggering handleChunkError
    let link = document.getElementById(linkId);
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.setAttribute('data-dynamic-font', 'true');
      link.href = fontUrl;
      document.head.appendChild(link);
    } else if (link.href !== fontUrl) {
      link.href = fontUrl;
    }

    // Inject or update the <style> override
    // #root * has ID-level specificity (1,0,0) which beats any class-based !important rule
    if (fontFamily) {
      let style = document.getElementById(styleId);
      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        document.head.appendChild(style);
      }
      style.textContent = `html, body, #root, #root * { font-family: '${fontFamily}', sans-serif !important; }`;
    }
  }, [settings?.google_font_url, settings?.google_font_name]);

  // Dynamic Header & Footer Script Injection
  useEffect(() => {
    const headerScript = settings?.script_setting?.header_script;
    const footerScript = settings?.script_setting?.footer_script;

    const injectScript = (scriptContent, target, id) => {
      if (!scriptContent || scriptContent === "undefined" || scriptContent === "null") return;

      const existing = document.getElementById(id);
      if (existing && existing.getAttribute('data-content') === scriptContent) return;
      if (existing) existing.remove();

      console.log(`[Dynamic Script] Injecting ${id}...`);

      const container = document.createElement('div');
      container.id = id;
      container.style.display = 'none';
      container.setAttribute('data-content', scriptContent);

      try {
        const range = document.createRange();
        range.selectNode(document.body);
        const fragment = range.createContextualFragment(scriptContent);

        // Before appending, let's see if we have scripts
        const scripts = fragment.querySelectorAll('script');
        if (scripts.length > 0) {
          console.log(`[Dynamic Script] Found ${scripts.length} script(s) in ${id}`);
        }

        container.appendChild(fragment);
        target.appendChild(container);
        console.log(`[Dynamic Script] ${id} appended to ${target.tagName}`);
      } catch (e) {
        console.error(`[Dynamic Script] Failed to inject ${id}:`, e);
      }
    };

    if (headerScript && headerScript.length > 10) {
      injectScript(headerScript, document.head, 'dynamic-header-scripts');
    }

    if (footerScript && footerScript.length > 10) {
      injectScript(footerScript, document.body, 'dynamic-footer-scripts');
    }
  }, [settings?.script_setting?.header_script, settings?.script_setting?.footer_script]);

  const backgroundImage = pageData;

  const [counter, setCounter] = useState(5); // Countdown timer
  const timerStarted = useRef(false); // To avoid multiple intervals

  const ServiceErrorModal500 = ({ show }) => {
    if (show && !timerStarted.current) {
      timerStarted.current = true;

      const interval = setInterval(() => {
        setCounter((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            window.location.href = "/"; // Redirect
          }
          return prev - 1;
        });
      }, 1000);
    }

    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable theme-bg-color">
        <div className="modalContentdataserviceunavailable theme-bg-color">
          <div className="col-lg-12 row justify-content-center theme-text-color ">
            <div className="col-lg-3">
              <div className="text-center">
                <h1 className="theme-button-bg-color counter_timing">{counter}</h1>
              </div>
            </div>
          </div>
          <h5>Your page is not working as expected, please wait for a while</h5>
          <p>
            Try again Later. If not redirected,{" "}
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault(); // prevent default anchor behavior
                window.location.href = "/"; // ✅ Manual redirect
              }}
              className="theme-text-color-button"
            >
              Click Here
            </a>.
          </p>
        </div>
      </div>
    );
  };


  const ServiceOfflineModal503 = ({ show }) => {
    if (show && !timerStarted.current) {
      timerStarted.current = true;

      const interval = setInterval(() => {
        setCounter((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            window.location.href = "/"; // Redirect
          }
          return prev - 1;
        });
      }, 1000);
    }

    if (!show) return null;

    return (
      <div className="modalBackdropdataserviceunavailable theme-bg-color">
        <div className="modalContentdataserviceunavailable theme-bg-color">
          <h2>You're offline</h2>
          <p>The internet is not available. Please try again later,{" "}
            <a
              onClick={(e) => {
                window.location.reload(); // ✅ Manual redirect
              }}
              className="theme-text-color-button"
            >
              Retry
            </a>.
          </p>
        </div>
      </div >
    );
  };

  const navigate = useNavigate();  // For navigation without reload
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        const status = err.response?.status;
        const currentPath = window.location.pathname || "";
        const requestUrl = String(err?.config?.url || "");
        const isAuthRelatedRequest =
          /\/(users|partner|admin)\/(login|signin|logout|sign-in|sign-out|authenticate|session|token|verify)/i.test(requestUrl) ||
          /\/(users|partner|admin)\//i.test(requestUrl);

        // A blacklisted/expired token (e.g. this device was logged out from another
        // device) returns 403 "Token has been Expired" on ANY endpoint. Sign this
        // device out + redirect so it does not sit on a dead token rendering 404s.
        // Guard: never do this for a device-restriction token (those 403 by design).
        const respMsg = String(err.response?.data?.message || "").toLowerCase();
        let isRestrictionToken = false;
        try {
          const _tk = localStorage.getItem("access_token");
          if (_tk) isRestrictionToken = !!(jwtDecode(_tk)?.isDeviceRestriction);
        } catch (e) { isRestrictionToken = false; }
        const tokenDead = status === 403 && /token has been expired|blacklist/.test(respMsg) && !isRestrictionToken;

        if ((([401, 403].includes(status) && isAuthRelatedRequest) || tokenDead)) {
          if (!sessionExpiredRef.current) {
            sessionExpiredRef.current = true;

            let savedLocation = localStorage.getItem("location");
            try {
              if (savedLocation?.startsWith('"')) {
                savedLocation = JSON.parse(savedLocation);
              }
            } catch {
              savedLocation = "/";
            }

            localStorage.clear();
            if (savedLocation) {
              localStorage.setItem("location", savedLocation);
            }

            const isPartnerRoute = currentPath.includes('/partner') || currentPath.includes('/channel');
            const redirectPath = isPartnerRoute ? "/partner" : (savedLocation || "/");

            requestAnimationFrame(() => {
              navigate(redirectPath, { replace: true });
            });
          }
        } else if ([401, 403].includes(status)) {
          // Non-auth API failures should stay local so one broken endpoint doesn't blank the app.
          console.warn('Non-auth 401/403 ignored by global interceptor:', requestUrl);
        }
        // else if (!navigator.onLine) {
        //   // 📴 Offline
        //   // toast.error("You are offline. Please check your connection.");
        //   setServiceOfflineModal503(true);
        // } else if (err.code === "ECONNABORTED" || !err.response) {
        //   // 🌐 Network/API timeout
        //   // toast.error("Service is unavailable. Please try again later.");
        //   setServiceError503(true);
        // } else if (status === 503 || status === 502) {
        //   setServiceError503(true);
        // } else if (status >= 500) {
        //   setServiceError500(true);
        // }

        return Promise.reject(err);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);


  // translate checkout enable
  useEffect(() => {
    const loadTranslations = async () => {
      if (siteTheme?.translate_checkout) {
        if (!languageDetailsData?.Language_Code) {
          try {
            const languageResponse = await dispatch(getUserTranslateLanguageAction(navigation));
            await dispatch(displayTranslateLanguageAction());
          } catch (error) {
            console.error("Failed to load translations:", error);
          }
        }
      }
    };
    loadTranslations();
  }, [siteTheme?.translate_checkout]);

  const [settingsFetched, setSettingsFetched] = useState(false);
  const [headerFetched, setHeaderFetched] = useState(false);

  // Optimize state initialization to prevent double-flash/remount-flash in React 18 Strict Mode
  const hasPreloadedData = () => {
    try {
      const hasSettings = settings && ('website_name' in settings || 'website_logo' in settings);
      const hasTheme = headerSetting !== null;
      const isHome = window.location.pathname === '/' || (siteTheme?.translate_checkout && window.location.pathname === `/${localStorage.getItem('user_language') || 'en'}`);
      const hasHomepage = homepage && homepage.length > 0;
      return !!(hasSettings && hasTheme && (!isHome || hasHomepage));
    } catch (e) {
      return false;
    }
  };

  const [isAppReady, setIsAppReady] = useState(hasPreloadedData);
  const [hasDoneInitialGlobalLoad, setHasDoneInitialGlobalLoad] = useState(hasPreloadedData);

  // Handle chunk loading errors and force refresh
  useEffect(() => {
    const handleChunkError = (event) => {
      if (
        event.target.tagName === 'LINK' &&
        event.target.rel === 'stylesheet' &&
        !event.target.getAttribute('data-dynamic-font')
      ) {
        console.warn('CSS chunk failed to load, forcing reload:', event.target.href);
        // Force reload to get fresh chunks
        window.location.reload();
      }
    };

    // Listen for CSS loading errors
    document.addEventListener('error', handleChunkError, true);

    return () => {
      document.removeEventListener('error', handleChunkError, true);
    };
  }, []);

  // Consolidated Initial Data Fetching (Parallel)
  useEffect(() => {
    const initApp = async () => {
      try {
        // Dispatch ONLY critical configuration actions that block initial page painting/styling
        const criticalActions = [
          dispatch(siteThemeAction()),
          dispatch(settingAction()),
          dispatch(headerIndexAction())
        ];

        await Promise.allSettled(criticalActions);
      } catch (error) {
        console.warn('Initial critical config loading partially failed:', error);
      } finally {
        // Render the React application instantly as soon as core theme data is resolved
        setIsAppReady(true);

        // Dispatch non-critical layout/translation metadata in the background
        // to prevent blocking the initial paint of the website.
        try {
          dispatch(labelAction());
          dispatch(footerAction());
          dispatch(getFieldEnable());
        } catch (backgroundError) {
          console.warn('Background meta loading failed:', backgroundError);
        }
      }
    };

    initApp();
  }, [dispatch]);

  // useEffect(() => {
  //   setupGlobalVideoJsErrorHandler();
  // }, []);


  // useEffect(() => {
  //   const handleScroll = () => {
  //     let bodyScrollTop = window.scrollY || document.documentElement.scrollTop;
  //     setBodyScrollTop(bodyScrollTop);
  //   };
  //   if (settings && Object.keys(settings).length) {
  //     const shouldDispatch = (!user_role && settings.access_free == 1) || user_role;
  //     window.addEventListener('scroll', handleScroll);
  //     if (isLaptop() && shouldDispatch && bodyScrollTop > 100 && !isActionDispatched) {
  //       dispatch(allHomePageAction());
  //       setIsActionDispatched(true);
  //     }
  //     else if (isMobile() && !isActionDispatched) {
  //       dispatch(allHomePageAction());
  //       setIsActionDispatched(true);
  //     }
  //   }
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [settings, user_role, bodyScrollTop, isActionDispatched]);


  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setBodyScrollTop(scrollTop);
    };

    const shouldDispatch = settings &&
      Object.keys(settings).length &&
      ((!user_role && settings.access_free == 1) || user_role);

    // 🚀 Dispatch immediately without scroll if conditions are met
    if (shouldDispatch && !isActionDispatched) {
      dispatch(allHomePageAction());
      setIsActionDispatched(true);
    }

    // 🎯 Only add scroll listener if needed
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [settings, user_role, isActionDispatched, dispatch]);


  // Removed manual getFieldEnable dispatch as it is now parallelized in initApp
  const isFirstCall = useRef(true);

  // When homepage  true to render
  useEffect(() => {
    const fetchThumbnails = async () => {
      await dispatch(allThumbnailAction(headers));
    };
    if (homepage) {
      fetchThumbnails();
    }
  }, [homepage, dispatch, headers]);


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location]);

  const routeEnable = siteTheme && Object.keys(siteTheme).length;

  // Show content immediately - don't wait for API calls
  useEffect(() => {
    if (window.location.pathname !== "/login") {
      // Run language checker/stripper logic
      const cleanedPath = siteTheme?.translate_checkout
        ? navigateTranslateChecker(window.location.pathname) // Or your own language-strip logic
        : window.location.pathname;

      localStorage.setItem('location', cleanedPath);
    }
  }, [location, siteTheme]);

  const isHomePage = location.pathname === '/' || (siteTheme?.translate_checkout && location.pathname === `/${localStorage.getItem('user_language') || 'en'}`);
  // Landing page is shown at "/" for guests when enabled & not free-access; once its data loads,
  // don't keep the global loader up waiting for home content (which isn't fetched in landing mode).
  const isLandingActive = settings?.enable_landing_page === "1" && Number(settings?.access_free) !== 1 && !localStorage.getItem("access_token");
  const isHomePageLoading = isHomePage && !(isLandingActive && pageData) && (!homepage || homepage.length === 0);

  useEffect(() => {
    if (isAppReady && (!isHomePageLoading || serviceOfflineModal503 || serviceError503 || serviceError500)) {
      setHasDoneInitialGlobalLoad(true);
    }
  }, [isAppReady, isHomePageLoading, serviceOfflineModal503, serviceError503, serviceError500]);

  const showGlobalLoader = !hasDoneInitialGlobalLoad;

  const landscapeSwiper = React.useMemo(() => {
    try {
      const sections = Array.isArray(homepage) ? homepage : (Array.isArray(homepage?.data) ? homepage.data : []);
      return sections?.some(s => Number(s?.web_orientation_view) === 2) ? 1 : 0;
    } catch (e) {
      return 0;
    }
  }, [homepage]);

  useEffect(() => {
    const currentHost = window.location.hostname.toLowerCase();
    const currentProtocol = window.location.protocol;
    const currentUrl = window.location.href;

    // Skip redirect for ALL localhost variations and IP addresses (development)
    if (currentHost.includes('localhost') ||
      currentHost === '127.0.0.1' ||
      /^\d+\.\d+\.\d+\.\d+/.test(currentHost) ||
      currentHost === 'www.localhost') {
      console.log('[Canonical Redirect] Skipping redirect for development host:', currentHost);
      return;
    }

    // Apply to any domain (not just specific domains)
    const bareHost = currentHost.replace(/^www\./i, '');  // remove leading www.
    if (bareHost && bareHost.length > 0) {
      const isWww = /^www\./i.test(currentHost);
      const isHttps = currentProtocol === 'https:';

      // Redirect if: www present OR protocol is not https
      if (isWww || !isHttps) {
        const targetUrl = `https://${bareHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
        console.log('[Canonical Redirect] Redirecting from', currentUrl, 'to', targetUrl);

        // Use window.location.replace for a clean redirect (no history entry)
        window.location.replace(targetUrl);
        return; // Stop further execution
      }
    }
  }, []); // Run only once on mount

  return (
    <>
      {showGlobalLoader && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 999999, backgroundColor: '#000000' }}>
        </div>
      )}
      <div className={`${isLoading && 'overflow-hidden heightBody'}`} style={{ opacity: showGlobalLoader ? 0 : 1, pointerEvents: showGlobalLoader ? 'none' : 'auto' }}>
        {/* <ServiceOfflineModal503 show={serviceOfflineModal503} />
        <ServiceErrorModal503 show={serviceError503} />
        <ServiceErrorModal500 show={serviceError500} /> */}
        <HelmetDetails
          pageTitle={pageMeta?.page_title}
          metaTitle={pageMeta?.page_title}
          metaDescription={pageMeta?.meta_description}
          metaKeywords={pageMeta?.meta_keyword}
          metaImage={pageMeta?.image_url}
        />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <ThemeProvider theme={themeMode}>
          <GlobalStyles flimStripe={flimStripe} settings={settings} backgroundImage={backgroundImage} planContent={planContent} landscapeSwiper={landscapeSwiper} enableButtonHover={siteTheme?.enable_button_hover} />
          <ChunkErrorBoundary>
            <HomePageProvider>
              <AllRoutes
                props={{
                  currentTheme: currentTheme,
                  flimStripe: flimStripe,
                  TranslateCheckOut: siteTheme,
                  lang: (() => {
                    if (languageDetailsData?.Language_Code) return languageDetailsData.Language_Code;

                    const savedLang = localStorage.getItem('user_language');
                    if (savedLang) return savedLang;

                    // Synchronous fallback for first-load (e.g., German browsers on kleeberg.tv)
                    const browserLang = navigator.language.split('-')[0];
                    if (browserLang === 'de') return 'de';

                    return "en";
                  })(),
                  landingpageData: pageData
                }}
              />
            </HomePageProvider>
          </ChunkErrorBoundary>
          {/* Global Radio Player Bar */}
          {siteTheme?.livestream_notification == 1 && showPopup && (
            <LivestreamPopup />
          )}
          <RadioPlayerBar />
          {/* CDN bandwidth restriction modal — shown when monthly limit is reached */}
          {bwRestricted && (
            <BandwidthRestrictedModal
              bandwidthInfo={bwInfo}
              onRecheck={bwRecheck}
              checking={bwChecking}
            />
          )}
        </ThemeProvider>
      </div>
    </>
  );

}
const mapStateToProps = state => ({
  settings: state.get_setting_Reducer.settings,
  themeMode: state.get_headerIndex_Reducer.themeMode,
  headerSetting: state.get_headerIndex_Reducer.headerSetting,
  headerindexall: state.get_headerIndex_Reducer.headerindexall,
  currentTheme: state.get_siteTheme_Reducer.currentTheme,
  siteTheme: state.get_siteTheme_Reducer.siteTheme,
  flimStripe: state.get_siteTheme_Reducer.flimStripe,
  isLoading: state.get_siteTheme_Reducer.isLoading,
  homepage: state.get_allHomePage_Reducer.homepage,
  languageDetailsData: state.get_getUserTranslateLanguage_Reducer.languageDetailsData,
  planContent: state.get_planContent_Reducer.content,
});
export default connect(mapStateToProps)(App)
